var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestingLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "testing library") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.279%",
    cy: "49.8468745%",
    fx: "50.279%",
    fy: "49.8468745%",
    r: "50.334%",
    gradientTransform: "translate(0.502790,0.498469),scale(1.000000,0.992517),translate(-0.502790,-0.498469)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33332",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03330",
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52E2C",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32827",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F23",
    offset: "71%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89181A",
    offset: "86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#640E0E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.003%",
    y1: "49.969%",
    x2: "100%",
    y2: "49.969%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B0C2",
    offset: "19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A4B6",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F390A5",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7728B",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4D6C",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4B6A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.025%",
    y1: "26.463%",
    x2: "100.015%",
    y2: "26.463%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B0C2",
    offset: "19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A4B6",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F390A5",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7728B",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4D6C",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4B6A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.879%",
    cy: "49.5849298%",
    fx: "50.879%",
    fy: "49.5849298%",
    r: "91.636%",
    gradientTransform: "translate(0.508790,0.495849),scale(1.000000,0.419379),translate(-0.508790,-0.495849)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B0C2",
    offset: "19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A4B6",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F390A5",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7728B",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4D6C",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4B6A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.5432107%",
    cy: "49.742%",
    fx: "50.5432107%",
    fy: "49.742%",
    r: "56.1219498%",
    gradientTransform: "translate(0.505432,0.497420),scale(0.815587,1.000000),translate(-0.505432,-0.497420)",
    id: "radialGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B0C2",
    offset: "19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A4B6",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F390A5",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7728B",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4D6C",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4B6A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.997%",
    x2: "99.996%",
    y2: "49.997%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4B6A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4D6C",
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7728B",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F390A5",
    offset: "42%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A4B6",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B0C2",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.004%",
    y1: "26.478%",
    x2: "99.975%",
    y2: "26.478%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4B6A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4D6C",
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7728B",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F390A5",
    offset: "42%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A4B6",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B0C2",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "51.992%",
    cy: "49.5817659%",
    fx: "51.992%",
    fy: "49.5817659%",
    r: "91.664%",
    gradientTransform: "translate(0.519920,0.495818),scale(1.000000,0.419250),translate(-0.519920,-0.495818)",
    id: "radialGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B0C2",
    offset: "19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A4B6",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F390A5",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7728B",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4D6C",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4B6A",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M249.809548,103.820437 C256.107254,128.347497 229.056436,157.070242 195.222697,148.931625 C238.315983,117.59037 218.614174,77.443232 195.839326,58.1835248 C171.14383,37.2960944 195.050849,30.6032197 203.016486,38.1655615 C202.824421,22.909447 149.106916,26.3569851 196.092043,75.3504449 C220.231562,100.51444 191.755421,156.180555 157.830704,113.849639 C157.550686,113.466478 157.297371,113.064495 157.072553,112.646539 C162.551455,110.371771 167.049816,104.1844 167.049816,93.9934371 C167.103515,90.3855695 166.386679,86.8077887 164.947212,83.4991714 C168.869378,75.5122062 172.468067,65.9682884 172.468067,54.0181708 C172.468067,25.4571878 153.938863,0 127.989891,0 C102.040919,0 83.511716,25.4571878 83.511716,54.0181708 C83.511716,65.9682884 87.1205134,75.5223163 91.0426798,83.5092815 C89.5979847,86.8233733 88.8809838,90.4088764 88.9400751,94.0237673 C88.9400751,104.21473 93.4283274,110.402101 98.9173385,112.67687 C98.6889882,113.094958 98.4323023,113.496931 98.1490791,113.879969 C64.2243618,156.210885 35.7381122,100.53466 59.8877397,75.3807752 C106.882975,26.3873153 53.1452527,22.9498873 52.9531878,38.1958917 C60.9188247,30.6436601 84.8359526,37.3365347 60.1303479,58.2138551 C37.3555004,77.4230118 17.6739078,117.58026 60.7469772,148.961956 C26.9233466,157.100572 -0.117362308,128.377828 6.16012562,103.850768 C-4.81789675,124.070933 3.3195876,162.307265 46.8980908,169.687625 C0.509375617,180.333542 14.4694575,244.391024 47.1305903,234.139401 C19.1194485,232.491457 22.2329208,200.250404 33.5647468,190.544725 C46.0995053,179.797707 61.9499096,187.370159 90.8506149,182.52743 C90.537246,208.550782 115.879697,222.533026 102.586788,237.435288 C88.505402,253.207016 69.2281565,236.171527 72.2001073,220.672771 C58.7555679,248.495718 97.0371248,270.636799 113.817527,238.324975 C126.746524,213.464282 92.3871337,168.565406 127.969674,168.565406 C163.552214,168.565406 129.182715,213.413732 142.121821,238.324975 C158.902223,270.677239 197.18378,248.495718 183.739241,220.672771 C186.680865,236.181637 167.433946,253.207016 153.362669,237.435288 C140.130411,222.492586 165.402102,208.510342 165.129168,182.486989 C194.019764,187.329719 209.870169,179.747157 222.394818,190.504285 C233.746862,200.209964 236.850225,232.451017 208.839084,234.09896 C241.55076,244.391024 255.500733,180.323432 209.091801,169.647184 C252.639978,162.276934 260.787571,124.030492 249.809548,103.820437 Z",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1005067,192.485861 C46.6251565,181.738843 61.0098027,191.14122 90.880941,182.486989 C90.880941,182.486989 91.2953967,174.500024 91.6795264,168.575516 C82.5817178,175.430152 65.9428367,174.540464 52.0535156,176.572591 C6.34208179,183.275576 16.4911927,238.183434 47.1305903,234.139401 C24.4568296,230.41889 22.758572,202.20165 34.1005067,192.485861 Z",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.438436,153.13742 C98.4927741,145.322326 99.1195121,132.725163 88.8996404,144.179887 C54.3684025,182.871172 -5.54572143,151.256944 6.19045165,103.830547 C-6.44539362,120.987357 -0.380187889,165.845793 46.9284168,169.657295 C58.8061113,165.714362 83.2589991,168.767607 93.438436,153.13742 Z",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7570858,148.931625 C60.7570858,148.931625 72.8874973,147.688085 80.7520474,138.44747 C48.7783045,150.336927 22.5462898,98.765396 62.5564302,63.9058315 C93.6709356,36.8310306 62.000453,26.1547834 52.9228618,38.1655615 C56.2688336,34.8595645 83.3803032,36.7299297 58.6746985,57.6173602 C35.9402857,76.8770674 11.8513103,116.862444 60.7570858,148.931625 Z",
    fill: "url(#radialGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.98713,242.65209 C137.674003,227.749829 150.98713,214.293309 153.433429,190.807587 C155.050818,174.965088 149.137242,157.444315 128,157.444315 C106.862758,157.444315 100.939074,174.995418 102.566571,190.807587 C104.982544,214.293309 118.315888,227.749829 105.01287,242.65209 C90.941593,258.413709 64.6287088,241.984825 72.2304333,220.632331 C53.5192737,251.700614 101.009835,271.041202 117.790237,238.739488 C130.709125,213.868685 92.4174597,170.28412 128,170.28412 C163.58254,170.28412 125.290875,213.868685 138.209763,238.739488 C154.990165,271.041202 202.470618,251.700614 183.759458,220.632331 C191.351074,241.984825 165.058407,258.403599 150.98713,242.65209 Z",
    fill: "url(#radialGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.946484,176.582701 C190.047055,174.560685 173.398065,175.430152 164.320474,168.575516 C164.714712,174.500024 165.119059,182.497099 165.119059,182.497099 C194.980089,191.14122 209.364735,181.728733 221.889385,192.485861 C233.231319,202.19154 231.533062,230.41889 208.818866,234.09896 C239.498699,238.183434 249.657918,183.275576 203.946484,176.582701 Z",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.809548,103.820437 C261.545721,151.236724 201.631598,182.871172 167.090251,144.159666 C156.870379,132.704943 157.466791,145.312216 162.561564,153.12731 C172.741001,168.757497 197.18378,165.704252 209.061475,169.647184 C256.380188,165.845793 262.445394,120.977247 249.809548,103.820437 Z",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.247953,138.44747 C183.112503,147.688085 195.232805,148.931625 195.232805,148.931625 C244.138581,116.902884 220.049606,76.8669573 197.254541,57.6173602 C172.538827,36.7299297 199.650297,34.8595645 202.996269,38.1655615 C193.89846,26.1547834 162.248195,36.8310306 193.3627,63.9058315 C233.443602,98.765396 207.211587,150.336927 175.247953,138.44747 Z",
    fill: "url(#radialGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.141279,35.53694 C141.141279,43.4228044 128,43.4228044 128,35.53694 C128,27.6510757 141.141279,27.6611857 141.141279,35.53694 Z M120.448819,42.7555389 C120.448819,48.1846532 111.421771,48.1846532 111.421771,42.7555389 C111.421771,37.3264246 120.448819,37.3264246 120.448819,42.7555389 Z M126.210764,17.7836351 C126.210764,23.2228595 117.173608,23.2228595 117.173608,17.7836351 C117.173608,12.3444107 126.210764,12.3949612 126.210764,17.7836351 Z M107.388409,56.3131596 C107.388409,59.0327718 102.869831,59.0327718 102.869831,56.3131596 C102.869831,53.5935474 107.388409,53.5935474 107.388409,56.3131596 Z M108.247647,29.6225417 C108.247647,33.3834924 102.000485,33.3834924 102.000485,29.6225417 C102.000485,25.8615911 108.247647,25.8717011 108.247647,29.6225417 Z M126.210764,62.6926216 C126.210764,66.4636824 119.963602,66.4636824 119.963602,62.6926216 C119.963602,58.9215608 126.210764,58.9518911 126.210764,62.6926216 Z",
    fill: "#4B1313",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.947422,93.9934371 C111.947422,108.329534 95.6926708,108.329534 95.6926708,93.9934371 C95.6926708,79.6573401 111.947422,79.6573401 111.947422,93.9934371 Z",
    fill: "#302D3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.617873,90.3436973 C103.703055,91.2895069 103.24666,92.2022815 102.438946,92.7015109 C101.631231,93.2007403 100.610828,93.2007403 99.8031142,92.7015109 C98.9953999,92.2022815 98.5390048,91.2895069 98.6241869,90.3436973 C98.5390048,89.3978876 98.9953999,88.4851131 99.8031142,87.9858837 C100.610828,87.4866543 101.631231,87.4866543 102.438946,87.9858837 C103.24666,88.4851131 103.703055,89.3978876 103.617873,90.3436973 Z",
    fill: "#6F828A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.347764,93.9934371 C160.347764,108.329534 144.093013,108.329534 144.093013,93.9934371 C144.093013,79.6573401 160.347764,79.6573401 160.347764,93.9934371 Z",
    fill: "#302D3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.967671,90.3436973 C152.052853,91.2895069 151.596458,92.2022815 150.788744,92.7015109 C149.981029,93.2007403 148.960627,93.2007403 148.152913,92.7015109 C147.345198,92.2022815 146.888803,91.2895069 146.973985,90.3436973 C146.888803,89.3978876 147.345198,88.4851131 148.152913,87.9858837 C148.960627,87.4866543 149.981029,87.4866543 150.788744,87.9858837 C151.596458,88.4851131 152.052853,89.3978876 151.967671,90.3436973 L151.967671,90.3436973 Z",
    fill: "#6F828A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.448819,122.52409 C120.448819,130.693037 119.771538,137.305031 118.993169,137.305031 C118.214801,137.305031 117.588064,130.693037 117.598172,122.5342 C117.608281,114.375363 118.275453,107.753259 119.06393,107.753259 C119.852407,107.753259 120.469036,114.355143 120.448819,122.52409 Z",
    fill: "#9E1C20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9E1C20",
    cx: 128.262826,
    cy: 122.51398,
    rx: 1.07151968,
    ry: 17.3590117
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.391719,122.331998 C138.391719,130.298743 137.744764,136.759086 136.976504,136.759086 C136.208245,136.759086 135.632051,130.318964 135.642159,122.342108 C135.652268,114.365253 136.309332,107.915021 137.057374,107.915021 C137.805416,107.915021 138.422045,114.365253 138.391719,122.331998 Z",
    fill: "#9E1C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.043776,145.099904 C197.365736,142.875686 207.130717,135.535766 208.828975,137.770094 C210.527233,140.004423 200.711708,147.334232 199.043776,145.099904 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.469859,143.724933 C200.711708,142.713925 206.059198,138.669892 206.827457,139.6809 C207.595716,140.691908 202.238118,144.746051 201.469859,143.724933 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.825939,135.323454 C202.804204,133.382319 210.234081,125.749206 212.235599,127.690342 C214.237117,129.631478 206.787022,137.2747 204.825939,135.323454 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.72637,133.837272 C205.806481,132.947585 209.870169,128.782231 210.769841,129.661808 C211.669513,130.541385 207.636151,134.726959 206.72637,133.837272 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.349071,121.159229 C212.680381,120.340312 215.783744,110.159459 218.452435,110.978376 C221.121125,111.797292 217.967218,121.988256 215.349071,121.159229 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.390265,118.955231 C215.167115,118.581158 216.875481,113.020612 218.078414,113.384575 C219.281346,113.748538 217.593197,119.329304 216.390265,118.955231 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.045537,144.725831 C186.862822,142.19831 197.588127,137.18371 198.760733,139.72134 C199.93334,142.258971 189.218143,147.253352 188.045537,144.725831 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.673793,143.917024 C190.138033,142.754365 195.990956,140.014533 196.536825,141.167082 C197.082693,142.319631 191.1489,145.069574 190.673793,143.917024 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.934615,130.308853 C212.599511,128.802451 218.381674,119.855028 220.70667,121.381651 C223.031665,122.908273 217.289937,131.825366 214.934615,130.308853 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.562112,128.478928 C215.490593,127.781333 218.654608,122.898163 219.716019,123.585649 C220.77743,124.273134 217.623523,129.166414 216.562112,128.478928 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.780677,159.112478 C172.862305,156.352426 182.900221,160.305468 181.889353,163.075631 C180.878485,165.845793 170.68894,161.882641 171.780677,159.112478 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.923716,160.335798 C174.419041,159.072038 179.92827,161.245706 179.443053,162.499356 C178.957837,163.753006 173.418282,161.629889 173.923716,160.335798 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.922715,162.357815 C186.680865,158.910277 197.042259,161.205266 196.294216,164.652804 C195.546174,168.100342 185.154455,165.805353 185.922715,162.357815 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.176949,163.368823 C188.530753,161.78154 194.242155,163.045301 193.858026,164.612363 C193.473896,166.179426 187.823146,164.885336 188.176949,163.368823 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.006346,147.1017 C165.553732,144.291098 174.307846,152.267953 171.770568,155.058335 C169.23329,157.848718 160.458959,149.902193 163.006346,147.1017 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.664169,149.214708 C165.836775,147.930727 170.618179,152.298283 169.455681,153.572153 C168.293183,154.846024 163.501671,150.539129 164.664169,149.214708 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.882797,166.229977 C199.882797,163.823777 208.859301,164.005758 208.808758,166.411958 C208.758214,168.818158 199.822144,168.646286 199.882797,166.229977 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.884314,166.583829 C201.884314,165.47172 206.787022,165.572821 206.776944,166.66471 C206.766805,167.756599 201.864097,167.675718 201.884314,166.583829 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.726339,175.703124 C167.484489,172.255586 177.845882,174.550574 177.107949,177.998113 C176.370016,181.445651 165.968188,179.150662 166.726339,175.703124 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.980573,176.663582 C169.334377,175.076299 175.045779,176.329949 174.661649,177.907122 C174.27752,179.484295 168.62677,178.220534 168.980573,176.663582 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.692186,164.450602 C121.692186,160.922183 134.247162,160.750312 134.297705,164.288841 C134.348249,167.82737 121.742729,167.989131 121.692186,164.450602 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.552941,164.865115 C124.552941,163.247502 131.416733,163.156511 131.447059,164.764015 C131.477385,166.371518 124.573159,166.472619 124.552941,164.865115 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.957046,168.676617 C140.413454,166.138986 148.065722,173.569896 145.568879,176.097417 C143.072036,178.624938 135.500638,171.214247 137.957046,168.676617 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.362152,170.678413 C140.504432,169.515753 144.659098,173.580007 143.547144,174.722446 C142.43519,175.864885 138.250198,171.820852 139.362152,170.678413 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.117784,178.715928 C153.635603,178.90802 153.0493,189.533717 149.521372,189.341625 C145.993444,189.149534 146.589856,178.533947 150.117784,178.715928 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53148,181.091798 C151.148869,181.182789 150.825391,186.996086 149.22822,186.905095 C147.631049,186.814105 147.924201,181.000807 149.53148,181.091798 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.062687,189.442726 C147.519854,190.150432 145.397032,200.563817 141.939864,199.886441 C138.482697,199.209066 140.605519,188.74513 144.062687,189.442726 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.163014,191.677054 C144.750076,192.010687 143.587579,197.743104 142.010625,197.399361 C140.433672,197.055618 141.575952,191.393972 143.163014,191.677054 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.479419,200.533487 C150.936586,201.241192 148.813764,211.654577 145.356597,210.967092 C141.89943,210.279606 144.022252,199.835891 147.479419,200.533487 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.55953,202.798145 C148.146592,203.121668 146.994203,208.864194 145.40714,208.510342 C143.820078,208.156489 144.992685,202.474622 146.55953,202.798145 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.564326,212.099421 C143.011384,212.797017 140.898671,223.220512 137.441504,222.522916 C133.984336,221.82532 136.086941,211.391715 139.564326,212.099421 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.634327,214.364079 C140.231498,214.697712 139.069,220.430129 137.492047,220.076276 C135.915093,219.722423 137.097809,214.040557 138.634327,214.364079 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.525409,224.29218 C145.043228,224.423611 144.64899,235.059418 141.121062,234.927987 C137.593134,234.796556 137.987372,224.160749 141.525409,224.29218 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.97954,226.68827 C142.607037,226.759041 142.384646,232.572338 140.777367,232.511677 C139.170087,232.451017 139.382369,226.627609 140.97954,226.68827 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.766499,239.356203 C142.50595,237.131985 148.116266,244.047282 145.366706,246.2715 C142.617146,248.495718 137.027048,241.570311 139.766499,239.356203 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.686389,241.216459 C141.949973,240.20545 145.012902,243.986621 143.718992,244.997629 C142.425081,246.008638 139.443021,242.227467 140.686389,241.216459 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.005829,245.907537 C150.421044,243.339576 156.890597,246.918545 155.475382,249.466286 C154.060167,252.014027 147.590614,248.475498 149.005829,245.907537 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.289631,247.039866 C150.936586,245.856986 154.474623,247.808232 153.837776,248.970892 C153.20093,250.133551 149.642676,248.212636 150.289631,247.039866 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.17364,253.732741 C157.385922,251.073789 163.73417,251.589403 163.51178,254.248355 C163.289389,256.907307 156.951249,256.381582 157.17364,253.732741 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.578746,254.177584 C158.679832,252.964374 162.147108,253.237347 162.05613,254.450557 C161.965152,255.663766 158.477659,255.370574 158.578746,254.177584 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.049057,252.145458 C165.482971,249.779698 171.103395,248.414837 171.689699,250.780597 C172.276002,253.146356 166.625252,254.511217 166.049057,252.145458 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.423837,252.125238 C167.17112,251.053569 170.254267,250.305423 170.517092,251.366981 C170.779918,252.42854 167.656337,253.207016 167.423837,252.125238 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.560563,252.337549 C173.630564,250.083001 178.998271,247.858783 179.918161,250.113331 C180.838051,252.36788 175.510778,254.541547 174.560563,252.337549 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.884799,252.064577 C175.470343,251.053569 178.40186,249.830249 178.826424,250.841257 C179.250988,251.852265 176.309364,253.095805 175.884799,252.064577 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.352075,246.33216 C177.572948,244.674107 181.535549,240.417762 183.304568,242.075816 C185.073586,243.733869 181.131202,247.990214 179.352075,246.33216 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.474138,245.573904 C179.665444,244.805538 181.818592,242.480219 182.627286,243.238475 C183.43598,243.996731 181.282832,246.33216 180.474138,245.573904 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.892389,238.729378 C183.557284,238.062113 185.174673,232.471237 187.509777,233.158723 C189.844881,233.846208 188.217384,239.416864 185.892389,238.729378 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.549453,237.556609 C185.538585,237.243196 186.367496,234.189951 187.428907,234.523584 C188.490318,234.857217 187.64119,237.880131 186.549453,237.556609 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.635118,184.165263 C179.938378,180.657064 190.532271,181.566972 190.218902,185.095391 C189.905533,188.623809 179.321749,187.693682 179.635118,184.165263 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.99044,184.822418 C182.14207,183.204805 187.924233,183.720419 187.782711,185.317812 C187.64119,186.915205 181.848918,186.419811 181.99044,184.822418 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.351833,180.464973 C192.422593,176.997214 203.046812,177.209526 202.965943,180.687395 C202.885073,184.165263 192.270963,183.942841 192.351833,180.464973 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.717263,180.960367 C194.717263,179.362974 200.560078,179.494405 200.529752,181.071578 C200.499426,182.648751 194.717263,182.57798 194.717263,180.960367 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.391266,184.862859 C205.149417,181.526531 214.408964,183.639539 213.620488,186.996086 C212.832011,190.352633 203.612898,188.219406 204.391266,184.862859 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.382675,185.772766 C206.736479,184.246144 211.790817,185.408803 211.437013,186.925315 C211.08321,188.441828 206.028872,187.309499 206.382675,185.772766 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.249502,185.115611 C218.816347,182.082586 226.549484,186.045738 224.962422,189.159644 C223.37536,192.273549 215.682657,188.178966 217.249502,185.115611 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79613,186.409701 C219.523954,185.0044 223.729164,187.198288 223.031665,188.573259 C222.334166,189.94823 218.078414,187.804893 218.79613,186.409701 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.397095,193.870942 C227.95459,192.718393 230.886106,199.209066 228.318503,200.361615 C225.750899,201.514165 222.829492,195.033602 225.397095,193.870942 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.730682,195.498665 C226.903288,194.962831 228.500459,198.53169 227.34807,199.037194 C226.195681,199.542698 224.558075,196.01428 225.730682,195.498665 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.564147,201.706234 C235.36425,201.706234 235.344033,208.833864 232.564147,208.783314 C229.784261,208.732763 229.753935,201.696146 232.564147,201.706234 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.190126,203.323831 C233.494145,203.323831 233.473928,207.216251 232.190126,207.216251 C230.906324,207.216251 230.916433,203.313759 232.190126,203.323831 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.824695,210.886211 C232.321539,211.341165 231.148932,217.720627 228.64198,217.245453 C226.135029,216.770279 227.307635,210.451477 229.824695,210.886211 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.228284,212.301623 C230.390781,212.524044 229.743826,216.001913 228.601546,215.789601 C227.459265,215.577289 228.075894,212.089311 229.228284,212.301623 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.09763,220.116716 C232.119365,221.238935 229.248501,226.354637 227.226766,225.171758 C225.20503,223.988878 228.075894,218.974277 230.09763,220.116716 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.228284,221.117614 C230.148173,221.643339 228.581328,224.433722 227.661439,223.907997 C226.741549,223.382273 228.298285,220.602 229.228284,221.117614 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.093076,226.910692 C225.498182,228.275553 222.020797,231.854522 220.615691,230.469441 C219.210585,229.08436 222.68797,225.52561 224.093076,226.910692 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.132752,227.537517 C223.779707,228.174452 221.869167,230.115588 221.232321,229.488763 C220.595474,228.861938 222.485797,226.910692 223.132752,227.537517 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.597993,164.774125 C209.799408,161.407467 220.140584,158.950717 220.949278,162.337595 C221.757972,165.724472 211.406687,168.171112 210.597993,164.774125 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.054402,164.662914 C212.690489,163.105961 218.331131,161.77143 218.705152,163.308163 C219.079173,164.844895 213.408205,166.199646 213.054402,164.662914 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.850468,165.684032 C222.8396,162.802659 232.867407,159.28435 233.878275,162.175833 C234.889142,165.067317 224.851227,168.585626 223.850468,165.684032 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.246224,165.259409 C225.781225,163.924878 231.300562,162.014072 231.735235,163.328383 C232.169908,164.642694 226.711223,166.583829 226.246224,165.259409 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.897733,158.12169 C230.875998,155.846922 238.720331,148.699094 240.7825,150.963752 C242.84467,153.22841 234.949794,160.386349 232.897733,158.12169 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.939686,156.78716 C233.999579,155.776151 238.315983,151.843329 239.245982,152.864447 C240.17598,153.885566 235.879793,157.818388 234.939686,156.78716 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.766078,150.791881 C243.208583,149.093387 249.122158,140.236954 251.669545,141.935448 C254.216931,143.633942 248.293247,152.490374 245.766078,150.791881 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.413792,149.002396 C246.251294,148.21381 249.486071,143.3913 250.63846,144.149556 C251.790849,144.907813 248.57629,149.770762 247.413792,149.002396 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.395093,138.164388 C246.524229,137.082609 250.304873,127.134288 253.15552,128.205956 C256.006167,129.277625 252.245739,139.256276 249.395093,138.164388 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.608134,136.0716 C249.294006,135.566096 251.366284,130.126872 252.629869,130.622266 C253.893454,131.11766 251.912153,136.546774 250.608134,136.0716 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68193,124.424785 C252.437804,124.677537 251.578567,116.852334 253.822693,116.599582 C256.066819,116.346829 256.936165,124.172033 254.68193,124.424785 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.772908,122.625191 C253.762041,122.726292 253.286933,118.449727 254.297801,118.348626 C255.308668,118.247525 255.803993,122.50387 254.772908,122.625191 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.283623,113.040833 C219.523954,112.7072 220.817865,102.132053 223.577534,102.485906 C226.337202,102.839759 225.043292,113.384575 222.283623,113.040833 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.930578,110.695293 C221.656885,110.543642 222.374601,104.760675 223.628077,104.912326 C224.881553,105.063977 224.194163,110.846945 222.930578,110.695293 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.149174,104.578693 C215.379397,104.811225 214.52016,94.1956387 217.310154,93.9732169 C220.100149,93.7507951 220.939169,104.356272 218.149174,104.578693 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.310913,102.142164 C217.03722,102.243264 216.58233,96.4501871 217.845914,96.3389762 C219.109499,96.2277653 219.584606,102.051173 218.310913,102.142164 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.131234,91.3749257 C218.604065,92.5375852 214.186573,82.8622362 216.723851,81.6995767 C219.261129,80.5369172 223.67862,90.2223763 221.131234,91.3749257 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.453953,89.0394966 C219.301564,89.5652209 216.88559,84.2877579 218.02787,83.7519235 C219.170151,83.2160891 221.61645,88.5542127 220.453953,89.0394966 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.720815,83.5901622 C210.446363,84.8640326 205.644742,76.2098019 207.929303,74.9460416 C210.213864,73.6822813 215.015485,82.3162918 212.720815,83.5901622 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.902013,81.4771549 C210.891145,82.0635397 208.242672,77.3421312 209.283865,76.7557464 C210.325059,76.1693616 212.973532,80.8907701 211.902013,81.4771549 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.164079,72.9240251 C209.223213,74.4405375 203.643224,67.2825991 205.604307,65.7559766 C207.56539,64.2293542 213.135271,71.3670724 211.164079,72.9240251 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.153212,71.1042103 C209.263648,71.801806 206.210828,67.889204 207.120609,67.1916083 C208.03039,66.4940126 211.052884,70.4066146 210.153212,71.1042103 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.793336,68.5665796 C199.923231,70.1943028 193.999547,63.3194467 195.879761,61.7018335 C197.759975,60.0842203 203.643224,66.9489664 201.793336,68.5665796 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.651056,66.8074252 C199.801927,67.5555713 196.607585,63.7744004 197.41628,63.0565846 C198.224974,62.3387687 201.520402,66.0693892 200.651056,66.8074252 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.537584,59.4068448 C195.849435,60.8626967 191.007379,55.2414908 192.705636,53.7856389 C194.403894,52.3297871 199.235841,57.9408828 197.537584,59.4068448 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.658129,57.9408828 C195.879761,58.6081483 193.231288,55.5346832 194.009656,54.9078581 C194.788024,54.281033 197.426388,57.2837275 196.658129,57.9408828 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.420317,57.59714 C187.519886,58.7496894 183.66848,52.4106677 185.589128,51.2480082 C187.509777,50.0853487 191.351074,56.4243705 189.420317,57.59714 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.793579,56.0098571 C187.934341,56.5355814 185.821628,53.0779332 186.690974,52.5420988 C187.56032,52.0062644 189.662925,55.4841328 188.793579,56.0098571 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.652057,49.9842479 C186.519127,50.611073 184.871412,45.1111881 187.02456,44.4742529 C189.177708,43.8373177 190.774879,49.3372026 188.652057,49.9842479 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.510536,48.649717 C187.499668,48.9429094 186.640431,45.9301048 187.620972,45.6166923 C188.601514,45.3032797 189.491077,48.3565246 188.510536,48.649717 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.738482,43.8575379 C180.635877,43.1195019 182.536308,37.7004977 184.649021,38.4486438 C186.761735,39.1967899 184.851195,44.6157941 182.738482,43.8575379 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.43598,42.7252087 C182.425113,42.401686 183.51685,39.4293218 184.446848,39.7730646 C185.376846,40.1168074 184.396305,43.0588414 183.43598,42.7252087 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.085971,37.5892868 C187.732168,35.3852888 193.393026,34.4956015 193.74683,36.7097096 C194.100634,38.9238176 188.429666,39.823615 188.085971,37.5892868 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.410208,37.6701674 C189.248469,36.6591592 192.351833,36.1839853 192.503463,37.1848835 C192.655093,38.1857816 189.571947,38.6811757 189.410208,37.6701674 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9663323,145.099904 C58.6342638,142.875686 48.8793913,135.535766 47.171025,137.770094 C45.4626587,140.004423 55.288292,147.334232 56.9663323,145.099904 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5301413,143.724933 C55.288292,142.713925 49.9408023,138.669892 49.1725429,139.6809 C48.4042835,140.691908 53.7618819,144.746051 54.5301413,143.724933 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1740608,135.323454 C53.195796,133.382319 45.765919,125.749206 43.7644011,127.690342 C41.7628832,129.631478 49.2129776,137.2747 51.1740608,135.323454 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2736297,133.837272 C50.1935192,132.947585 46.1298314,128.782231 45.2301592,129.661808 C44.330487,130.541385 48.3638488,134.726959 49.2736297,133.837272 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6509289,121.159229 C43.3196194,120.340312 40.2162558,110.159459 37.5475653,110.978376 C34.8788747,111.797292 38.0327817,121.988256 40.6509289,121.159229 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6097352,118.955231 C40.832885,118.581158 39.1245187,113.020612 37.9215863,113.384575 C36.7186538,113.748538 38.4068027,119.329304 39.6097352,118.955231 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.964572,144.725831 C69.1371784,142.19831 58.411873,137.18371 57.2392665,139.72134 C56.0666601,142.258971 66.7818569,147.253352 67.964572,144.725831 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3767509,143.917024 C65.9125107,142.754365 60.0595872,140.014533 59.5137187,141.167082 C58.9678501,142.319631 64.8510997,145.069574 65.3767509,143.917024 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0653846,130.308853 C43.4004888,128.802451 37.618326,119.855028 35.2933305,121.381651 C32.9683349,122.908273 38.710063,131.825366 41.0653846,130.308853 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4378877,128.478928 C40.5094074,127.781333 37.3453917,122.898163 36.2839807,123.585649 C35.2225697,124.273134 38.3764767,129.166414 39.4378877,128.478928 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6944311,158.809176 C83.5016073,155.776151 72.1293466,160.224588 73.3221704,163.287943 C74.5149942,166.351298 85.8973636,161.862421 84.6944311,158.809176 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2784575,160.214477 C81.7224803,158.809176 75.5056444,161.225486 76.0414043,162.651007 C76.5771641,164.076529 82.824326,161.599559 82.2784575,160.214477 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0772853,162.357815 C69.3191346,158.910277 58.9577415,161.205266 59.7057835,164.652804 C60.4538256,168.100342 70.8455447,165.805353 70.0772853,162.357815 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8230505,163.368823 C67.4692468,161.78154 61.7578448,163.045301 62.1419745,164.612363 C62.5261042,166.179426 68.1768542,164.885336 67.8230505,163.368823 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9936543,147.1017 C90.4462679,144.291098 81.6921543,152.267953 84.229432,155.058335 C86.7667097,157.848718 95.5410407,149.902193 92.9936543,147.1017 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3358314,149.214708 C90.1632249,147.930727 85.3818211,152.298283 86.5443189,153.572153 C87.7068166,154.846024 92.4983291,150.539129 91.3358314,149.214708 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6132875,165.957004 C57.5425268,163.368823 48.3739575,163.500254 48.4548269,166.098545 C48.5356963,168.696837 57.6840483,168.565406 57.6132875,165.957004 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5511176,166.320967 C55.5511176,165.127978 50.4967795,165.218968 50.4967795,166.391738 C50.4967795,167.564507 55.5814436,167.513957 55.5511176,166.320967 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2736614,175.703124 C88.5155107,172.255586 78.1541176,174.550574 78.892051,177.998113 C79.6299843,181.445651 90.0318121,179.150662 89.2736614,175.703124 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0194266,176.663582 C86.665623,175.076299 80.9542209,176.329949 81.3383506,177.907122 C81.7224803,179.484295 87.3732303,178.220534 87.0194266,176.663582 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.588822,169.333772 C116.567087,166.442288 107.853408,172.538668 109.875144,175.399821 C111.896879,178.260975 120.610558,172.235366 118.588822,169.333772 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.880456,171.082816 C115.940349,169.758395 111.189271,173.104833 112.099052,174.409033 C113.008833,175.713234 117.790237,172.397127 116.880456,171.082816 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.882216,178.715928 C102.364397,178.90802 102.9507,189.533717 106.478628,189.341625 C110.006556,189.149534 109.410144,178.533947 105.882216,178.715928 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.46852,181.091798 C104.851131,181.182789 105.174609,186.996086 106.77178,186.905095 C108.368951,186.814105 108.075799,181.000807 106.46852,181.091798 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.937313,189.442726 C108.480146,190.150432 110.602968,200.563817 114.060136,199.886441 C117.517303,199.209066 115.394481,188.74513 111.937313,189.442726 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.836986,191.677054 C111.249924,192.010687 112.412421,197.743104 113.989375,197.399361 C115.566328,197.055618 114.424048,191.393972 112.836986,191.677054 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.520581,200.533487 C105.063414,201.241192 107.186236,211.654577 110.643403,210.967092 C114.10057,210.279606 111.977748,199.835891 108.520581,200.533487 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.44047,202.798145 C107.853408,203.121668 109.005797,208.864194 110.59286,208.510342 C112.179922,208.156489 111.007315,202.474622 109.44047,202.798145 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.435674,212.099421 C112.988616,212.797017 115.101329,223.220512 118.558496,222.522916 C122.015664,221.82532 119.913059,211.391715 116.435674,212.099421 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.365673,214.364079 C115.768502,214.697712 116.931,220.430129 118.507953,220.076276 C120.084907,219.722423 118.902191,214.040557 117.365673,214.364079 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.474591,224.29218 C110.966881,224.423611 111.35101,235.059418 114.878938,234.927987 C118.406866,234.796556 118.012628,224.160749 114.474591,224.29218 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.02046,226.68827 C113.392963,226.759041 113.615354,232.572338 115.222633,232.511677 C116.829913,232.451017 116.617631,226.627609 115.02046,226.68827 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.233501,239.356203 C113.49405,237.131985 107.883734,244.047282 110.633294,246.2715 C113.382854,248.495718 118.972952,241.570311 116.233501,239.356203 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.313611,241.216459 C114.050027,240.20545 110.987098,243.986621 112.281008,244.997629 C113.574919,246.008638 116.556979,242.227467 115.313611,241.216459 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.994171,245.907537 C105.578956,243.339576 99.1094034,246.918545 100.524618,249.466286 C101.939833,252.014027 108.409386,248.475498 106.994171,245.907537 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.760912,247.039866 C105.113957,245.856986 101.57592,247.808232 102.212767,248.970892 C102.849614,250.133551 106.357324,248.212636 105.760912,247.039866 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8263605,253.732741 C98.6140783,251.073789 92.2658296,251.589403 92.4882205,254.248355 C92.7106113,256.907307 99.0487513,256.381582 98.8263605,253.732741 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4212545,254.177584 C97.3201677,252.964374 93.8528918,253.237347 93.9438698,254.450557 C94.0348479,255.663766 97.5223412,255.370574 97.4212545,254.177584 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9509427,252.145458 C90.5170286,249.779698 84.8966046,248.414837 84.3103014,250.780597 C83.7239982,253.146356 89.3747482,254.511217 89.9509427,252.145458 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5761628,252.125238 C88.8288797,251.053569 85.7457334,250.305423 85.4829079,251.366981 C85.2200823,252.42854 88.3436632,253.207016 88.5761628,252.125238 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4394374,252.337549 C82.3694356,250.083001 77.0017285,247.858783 76.081839,250.113331 C75.1619494,252.36788 80.4892218,254.541547 81.4394374,252.337549 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1152008,252.064577 C80.5296565,251.053569 77.5981404,249.830249 77.173576,250.841257 C76.7490116,251.852265 79.6906364,253.095805 80.1152008,252.064577 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6479248,246.33216 C78.4270519,244.674107 74.4644508,240.417762 72.6954324,242.075816 C70.9264141,243.733869 74.8687978,247.990214 76.6479248,246.33216 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5258618,245.573904 C76.3345559,244.805538 74.1814078,242.480219 73.3727138,243.238475 C72.5640197,243.996731 74.7171677,246.33216 75.5258618,245.573904 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1076113,238.729378 C72.4427155,238.062113 70.8253273,232.471237 68.4902231,233.158723 C66.1551189,233.846208 67.7826158,239.416864 70.1076113,238.729378 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4505474,237.556609 C70.461415,237.243196 69.6325036,234.189951 68.5710926,234.523584 C67.5096815,234.857217 68.3588104,237.880131 69.4505474,237.556609 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3648819,184.165263 C76.0616216,180.657064 65.467729,181.566972 65.7810979,185.095391 C66.0944669,188.623809 76.6782509,187.693682 76.3648819,184.165263 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0095604,184.822418 C73.8579302,183.204805 68.0757674,183.720419 68.2172889,185.317812 C68.3588104,186.915205 74.1510818,186.419811 74.0095604,184.822418 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6481672,180.464973 C63.5774065,176.997214 52.9531878,177.209526 53.0340572,180.687395 C53.1149266,184.165263 63.7290366,183.942841 63.6481672,180.464973 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.282737,180.960367 C61.282737,179.362974 55.4399222,179.494405 55.4702482,181.071578 C55.5005742,182.648751 61.282737,182.57798 61.282737,180.960367 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6087339,184.862859 C50.8505832,181.526531 41.6011444,183.639539 42.3795125,186.996086 C43.1578806,190.352633 52.3871019,188.219406 51.6087339,184.862859 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6173247,185.772766 C49.263521,184.246144 44.2091829,185.408803 44.5629865,186.925315 C44.9167902,188.441828 49.9711283,187.309499 49.6173247,185.772766 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7504977,185.115611 C37.1836529,182.082586 29.4505156,186.045738 31.0375778,189.159644 C32.6246399,192.273549 40.3173425,188.178966 38.7504977,185.115611 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2038703,186.409701 C36.4760456,185.0044 32.2708363,187.198288 32.9683349,188.573259 C33.6658336,189.94823 37.9215863,187.804893 37.2038703,186.409701 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6029047,193.870942 C28.0454096,192.718393 25.1138935,199.209066 27.6814973,200.361615 C30.249101,201.514165 33.1705085,195.033602 30.6029047,193.870942 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2693184,195.498665 C29.0967119,194.962831 27.4995411,198.53169 28.6519302,199.037194 C29.8043193,199.542698 31.4419248,196.01428 30.2693184,195.498665 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4358533,201.706234 C20.63575,201.706234 20.6559673,208.833864 23.4358533,208.783314 C26.2157392,208.732763 26.2460653,201.696146 23.4358533,201.706234 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8098743,203.323831 C22.5058551,203.323831 22.5260724,207.216251 23.8098743,207.216251 C25.0936762,207.216251 25.0936762,203.313759 23.8098743,203.323831 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1753045,210.886211 C23.6784615,211.341165 24.8510679,217.720627 27.3580196,217.245453 C29.8649713,216.770279 28.6923649,210.451477 26.1753045,210.886211 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7717164,212.301623 C25.6092187,212.524044 26.2561739,216.001913 27.3984543,215.789601 C28.5407348,215.577289 27.9241055,212.089311 26.7717164,212.301623 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9023703,220.116716 C23.880635,221.238935 26.7514991,226.354637 28.7732343,225.171758 C30.7949695,223.988878 27.9241055,218.974277 25.9023703,220.116716 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7717164,221.117614 C25.8518269,221.643339 27.4186717,224.433722 28.3385612,223.907997 C29.2584508,223.382273 27.7017146,220.602 26.7717164,221.117614 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9069239,226.910692 C30.5018179,228.275553 33.9286592,231.854522 35.3843085,230.469441 C36.8399579,229.08436 33.3120299,225.52561 31.9069239,226.910692 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8672482,227.537517 C32.2202929,228.174452 34.1308327,230.115588 34.7676793,229.488763 C35.4045259,228.861938 33.5142034,226.910692 32.8672482,227.537517 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4020067,164.774125 C46.2005921,161.407467 35.8594163,158.950717 35.0507222,162.337595 C34.2420281,165.724472 44.5933126,168.171112 45.4020067,164.774125 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9455984,164.662914 C43.3095107,163.105961 37.6688694,161.77143 37.2948484,163.308163 C36.9208273,164.844895 42.5917947,166.199646 42.9455984,164.662914 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1495322,165.684032 C33.1603998,162.802659 23.132593,159.28435 22.1217254,162.175833 C21.1108577,165.067317 31.1487732,168.585626 32.1495322,165.684032 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7537759,165.259409 C30.218775,163.924878 24.6994378,162.014072 24.2647647,163.328383 C23.8300916,164.642694 29.2887768,166.583829 29.7537759,165.259409 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.102267,158.12169 C25.1240022,155.846922 17.2796695,148.699094 15.2174995,150.963752 C13.1553296,153.22841 21.0502057,160.386349 23.102267,158.12169 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0603144,156.78716 C22.0004212,155.776151 17.6840165,151.843329 16.7540183,152.864447 C15.8240201,153.885566 20.1202075,157.818388 21.0603144,156.78716 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2339221,150.791881 C12.7914172,149.093387 6.87784163,140.236954 4.33045523,141.935448 C1.78306882,143.633942 7.70675308,152.490374 10.2339221,150.791881 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58620791,149.002396 C9.74870567,148.21381 6.56447267,143.3913 5.3615402,144.149556 C4.15860773,144.907813 7.42371015,149.770762 8.58620791,149.002396 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60490737,138.164388 C9.47577142,137.082609 5.69512651,127.134288 2.84447982,128.205956 C-0.00616686953,129.277625 3.75426068,139.256276 6.60490737,138.164388 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39186623,136.0716 C6.70599414,135.566096 4.63371551,130.126872 3.37013099,130.622266 C2.10654646,131.11766 4.087847,136.546774 5.39186623,136.0716 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31806971,124.424785 C3.56219583,124.677537 4.42143331,116.852334 2.17730719,116.599582 C-0.0668189268,116.346829 -0.936165081,124.172033 1.31806971,124.424785 Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22709163,122.625191 C2.23795925,122.726292 2.71306703,118.449727 1.70219941,118.348626 C0.691331789,118.247525 0.196006655,122.50387 1.22709163,122.625191 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.716377,113.040833 C36.4760456,112.7072 35.182135,102.132053 32.4224664,102.485906 C29.6627978,102.839759 30.9567084,113.384575 33.716377,113.040833 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0694217,110.695293 C34.3431149,110.543642 33.6253989,104.760675 32.371923,104.912326 C31.1184472,105.063977 31.8058372,110.846945 33.0694217,110.695293 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8508255,104.578693 C40.6206028,104.811225 41.4798403,94.1956387 38.6898457,93.9732169 C35.899851,93.7507951 35.0608309,104.356272 37.8508255,104.578693 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6890867,102.142164 C38.9627799,102.243264 39.4176704,96.4501871 38.1540858,96.3389762 C36.8905013,96.2277653 36.4153935,102.051173 37.6890867,102.142164 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8687661,91.3749257 C37.3959351,92.5375852 41.8134266,82.8622362 39.2761489,81.6995767 C36.7388712,80.5369172 32.3213797,90.2223763 34.8687661,91.3749257 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5460474,89.0394966 C36.6984365,89.5652209 39.1144101,84.2877579 37.9721297,83.7519235 C36.8298492,83.2160891 34.3835496,88.5542127 35.5460474,89.0394966 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2791847,83.5901622 C45.5536368,84.8640326 50.355258,76.2098019 48.0706972,74.9460416 C45.7861364,73.6822813 40.9845152,82.3162918 43.2791847,83.5901622 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0979874,81.4771549 C45.1088551,82.0635397 47.7573282,77.3421312 46.7161346,76.7557464 C45.6749409,76.1693616 43.0264678,80.8907701 44.0979874,81.4771549 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8359208,72.9240251 C46.7767866,74.4405375 52.3567759,67.2825991 50.3956927,65.7559766 C48.4346095,64.2293542 42.8647289,71.3670724 44.8359208,72.9240251 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8467884,71.1042103 C46.7363519,71.801806 49.7891721,67.889204 48.8793913,67.1916083 C47.9696104,66.4940126 44.9471162,70.4066146 45.8467884,71.1042103 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2066637,68.5665796 C56.0767688,70.1943028 62.000453,63.3194467 60.1202392,61.7018335 C58.2400255,60.0842203 52.3567759,66.9489664 54.2066637,68.5665796 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3489441,66.8074252 C56.1980729,67.5555713 59.3924146,63.7744004 58.5837205,63.0565846 C57.7750264,62.3387687 54.4795979,66.0693892 55.3489441,66.8074252 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4624163,59.4068448 C60.1505653,60.8626967 64.9926212,55.2414908 63.2943636,53.7856389 C61.596106,52.3297871 56.7641587,57.9408828 58.4624163,59.4068448 Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3418712,57.9408828 C60.1202392,58.6081483 62.7687124,55.5346832 61.9903443,54.9078581 C61.2119763,54.281033 58.5736118,57.2837275 59.3418712,57.9408828 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5796833,57.59714 C68.4801145,58.7496894 72.3315201,52.4106677 70.4108716,51.2480082 C68.4902231,50.0853487 64.6489262,56.4243705 66.5796833,57.59714 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2064213,56.0098571 C68.0656587,56.5355814 70.1783721,53.0779332 69.3090259,52.5420988 C68.4396798,52.0062644 66.3370751,55.4841328 67.2064213,56.0098571 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3479427,49.9842479 C69.4808734,50.611073 71.1285876,45.1111881 68.9754396,44.4742529 C66.8222916,43.8373177 65.2251207,49.3372026 67.3479427,49.9842479 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4894642,48.649717 C68.5003318,48.9429094 69.3595693,45.9301048 68.3790277,45.6166923 C67.3984861,45.3032797 66.5089226,48.3565246 67.4894642,48.649717 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2615183,43.8575379 C75.364123,43.1195019 73.4738005,37.7004977 71.3509785,38.4486438 C69.2281565,39.1967899 71.148805,44.6157941 73.2615183,43.8575379 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5640197,42.7252087 C73.5748873,42.401686 72.4831502,39.4293218 71.553152,39.7730646 C70.6231538,40.1168074 71.6036954,43.0588414 72.5640197,42.7252087 Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9140286,37.5892868 C68.2678323,35.3852888 62.6069736,34.4956015 62.2531699,36.7097096 C61.8993663,38.9238176 67.5703336,39.823615 67.9140286,37.5892868 Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.589792,37.6701674 C66.7515308,36.6591592 63.6481672,36.1839853 63.4965371,37.1848835 C63.3449069,38.1857816 66.4280532,38.6811757 66.589792,37.6701674 Z",
    fill: "#E34E70"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingLibrary);
export default __webpack_public_path__ + "static/media/testing-library.95f68fd1c556f2a881a89b7a7590f9af.svg";
export { ForwardRef as ReactComponent };